import { compose, getCookieFlag, setCookieFlag } from 'modules/core'
import React from 'react'
import ReadinessDetailedView from '../components/ReadinessDetailView'
import { withApollo } from '@apollo/client/react/hoc';
import { getAiTipCacheTimer, getIntFromString,globalPermissionValidator, parseMarkDownText } from "../../look";
import { withDeleteReadiness } from './ReadinessOperations'
import { GET_TOOL_ID_FOR_REPORTED_ID } from '../graphql/getToolidForReported.gql'
import { GET_TOOL_ID_FOR_REPORTED_RECEIVED_ID } from '../graphql/getToolByIdReceived.gql'
import { READINESS_REPORT_TOOL_ID } from '../../../config';
import { readiness_permission } from 'Permissions/readiness.permission';
import { READINESS_DETAIL } from '../graphql/ReadinessDetail.gql';
import NoPermissionView from 'modules/kudos-user/component/NoPermissionComponent';
import { ai_trigger_content } from 'modules/ai-tips/ai-trigger-content';
import { zone_detail_content } from '../config/zons-detail';

const ReadinessDetailComponent = (props) => {
    const { client, me, SetAITrigger, userPermission, readiness_detail } = props
    // eslint-disable-next-line no-unused-vars
    const [id, setid] = React.useState()
    const [toolIdData, setToolIdData] = React.useState()
    const [toolLoading, setToolLoading] = React.useState(true)
    const [submittedByMe, setsubmittedByMe] = React.useState(false);
    const [answerList, setanswerList] = React.useState([]);
    const [permission, setpermission] = React.useState()
    const [readinessById, setreadinessById] = React.useState()
    const mountedRef = React.useRef(true)
    let readinessLevelSub = undefined
    const childRef = React.useRef();

    React.useEffect(() => {
        return () => {
            if (readinessLevelSub) {
                readinessLevelSub.unsubscribe();
            }
        }
    })

    React.useEffect(() => {
        return () => {
            mountedRef.current = false
        }
    }, [])

    React.useEffect(() => {
        mountedRef.current = true
    }, [])

    React.useEffect(() => {
        if (userPermission?.length && readiness_detail) {
            setToolLoading(true)
            let permission = globalPermissionValidator(readiness_permission, userPermission)
            if (permission?.required_permission) {
                getReadinessDetail(readiness_detail?.id)
            }
            setpermission(permission)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userPermission, readiness_detail])

    React.useEffect(() => {
        if (readiness_detail && readinessById && me) {
            AiTipTrigger(readinessById, readiness_detail)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [readiness_detail, readinessById, me])

    const AiTipTrigger = async (readinessById, readiness_detail) => {
        
        let me_id = getIntFromString(me?.employee?.id)
        let readiness_to = getIntFromString(readinessById?.readinessTo?.user?.employee?.id)
        let userType = "employee" 
        let tipFor = null
        let optype = 'CREATE'
        let objectId = readiness_detail?.id
        if (!readiness_detail?.readinesslevelSet?.edges?.length) {
            return
        }
        let response_set = readiness_detail?.readinesslevelSet?.edges[0]?.node?.response?.answerSet?.edges?.map(({ node }) => {
            return `${parseMarkDownText(node?.question?.questionText)} : ${node?.answer}/100`
        })
        if (SetAITrigger && readiness_detail?.zone_detail?.length) {
            if (me_id !== readiness_to) {
                let cache_data = JSON.stringify({
                    optype,
                    objectId: readiness_detail?.id,
                    userType: "manager",
                    type: `readiness_assessment_skill_summary_${getIntFromString(readiness_detail?.id)}`,
                    data: { objectId: readiness_detail?.id }
                })
                let cached_trigger = await getCookieFlag(`readiness_assessment_skill_summary_${getIntFromString(readiness_detail?.id)}_${getIntFromString(me?.id)}`)
           
                tipFor = getIntFromString(readinessById?.readinessTo?.user?.id) 
                if (!cached_trigger || cache_data !== cached_trigger) {
                    let ai_trigger = {
                        trigger: ai_trigger_content.readiness_assessment_skill_summary,
                        dynamic_data: [readiness_detail?.zone_detail[0]?.zone?.zone, readiness_detail?.zone_detail[0]?.skill?.title, response_set?.join(","),zone_detail_content[readiness_detail?.zone_detail[0]?.zone?.color],`reportee: ${readinessById?.readinessTo?.user?.firstName}`],
                        userType:"manager",
                        tipFor,
                        optype,
                        objectId
                    }
                    SetAITrigger(ai_trigger)

                    setCookieFlag(`readiness_assessment_skill_summary_${getIntFromString(readiness_detail?.id)}_${getIntFromString(me?.id)}`, cache_data, { expires: getAiTipCacheTimer() })
                }

            }
            else {
                let cache_data = JSON.stringify({
                    optype,
                    objectId: readiness_detail?.id,
                    userType: "employee",
                    type: `readiness_assessment_skill_summary_${getIntFromString(readiness_detail?.id)}`,
                    data: { objectId: readiness_detail?.id }
                })
                let cached_trigger = await getCookieFlag(`readiness_assessment_skill_summary_${getIntFromString(objectId)}_${getIntFromString(me?.id)}`)
                if (!cached_trigger || cache_data !== cached_trigger) {
                    let ai_trigger = {
                        trigger: ai_trigger_content.readiness_assessment_skill_summary,
                        dynamic_data: [readiness_detail?.zone_detail[0]?.zone?.zone, readiness_detail?.zone_detail[0]?.skill?.title, response_set?.join(","),zone_detail_content[readiness_detail?.zone_detail[0]?.zone?.color],""],
                        userType, 
                        optype, 
                    }
                    SetAITrigger(ai_trigger)

                    setCookieFlag(`readiness_assessment_skill_summary_${getIntFromString(readiness_detail?.id)}_${getIntFromString(me?.id)}`, cache_data, { expires: getAiTipCacheTimer() })
                }
            }
        }
    }
    const getReadinessDetail = async (id) => {
        const { data } = await client.query({
            query: READINESS_DETAIL,
            fetchPolicy: 'network-only',
            variables: { id },
        });

        if (data?.readinessById) {
            setreadinessById(data?.readinessById)
        }
    }

    const getTools = async (id) => {
        let answer = answerList
        let toolId = []
        let responseToolId = {}
        if (me?.employee?.id === readinessById?.readinessTo?.user?.employee?.id) {
            try {
                await Promise.all(answer.map(async list => {
                    await client.query({
                        query: GET_TOOL_ID_FOR_REPORTED_RECEIVED_ID,
                        variables: { toolId: READINESS_REPORT_TOOL_ID, responseId: getIntFromString(list?.response?.id) },
                        fetchPolicy: 'network-only'
                    }).then(({ data }) => {
                        if (data?.getToolById != null) {
                            toolId.push(list?.response?.id)
                            responseToolId[list?.response?.id] = data
                        }
                    });
                })
                )
            }
            catch (error) {

            }
        } else {
            try {
                await Promise.all(answer.map(async list => {
                    await client.query({
                        query: GET_TOOL_ID_FOR_REPORTED_ID,
                        variables: { toolId: READINESS_REPORT_TOOL_ID, employeeId: getIntFromString(id), responseId: getIntFromString(list?.response?.id) },
                        fetchPolicy: 'network-only'
                    }).then(({ data }) => {
                        if (data?.getToolForReporteeByToolId != null) {
                            toolId.push(list?.response?.id)
                            responseToolId[list?.response?.id] = data
                        }
                    });

                })
                )
            }
            catch (error) {

            }
        }
        for (const [key, value] of Object.entries(responseToolId)) {
            if (value?.getToolForReporteeByToolId) {
                let s = value?.getToolForReporteeByToolId?.textsection.edges.sort((a, b) => a?.node?.sequence - b?.node?.sequence)
                responseToolId[key].getToolForReporteeByToolId.textsection.edges = s
            }
            else {

                let resTool = value?.getToolById?.textsection.edges.sort((a, b) => a?.node?.sequence - b?.node?.sequence)
                if (responseToolId[key]?.getToolById?.textsection?.edges) {
                    responseToolId[key].getToolById.textsection.edges = resTool
                }
            }
        }
        setToolIdData(responseToolId)
        setTimeout(() => {
            setToolLoading(false)
        }, 3000)

    }

    React.useEffect(() => {
        if (permission?.required_permission && toolIdData) {
            childRef.current.rerender()
        }

    }, [toolIdData, permission])

    const anserListFn = (id) => {
        getTools(id)
        setid(id)
    }

    React.useEffect(() => {
        if (readinessById && me) {
            if (me?.employee?.id === readinessById?.readinessFrom?.user?.employee?.id) {
                setsubmittedByMe(true)
            }
            else {
                setsubmittedByMe(false)
            }
            let list = readinessById?.readinesslevelSet?.edges?.map(({ node }) => node)
            setanswerList(list)
        }

        localStorage.removeItem('emailRoute')

    }, [readinessById, me])

    React.useEffect(() => {
        if (answerList) {
            if (submittedByMe) {
                anserListFn(readinessById?.readinessTo?.id)
            }
            else {
                anserListFn(readinessById?.readinessTo?.id)
            }
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [answerList])


    return (
        <>
            {(toolIdData && permission && permission?.required_permission) && (
                < ReadinessDetailedView
                    {...props}
                    getToolById={toolIdData}
                    submittedByMe={submittedByMe}
                    ref={childRef}
                    answerList={answerList}
                    toolIdData={toolIdData}
                    readinessById={readinessById}
                    toolLoading={toolLoading}
                />)}

            {
                (permission && !permission?.required_permission && !toolLoading) && (
                    <NoPermissionView />
                )
            }
        </>

    )
}
export default compose(withDeleteReadiness, withApollo,)(ReadinessDetailComponent)

// withReadinessDetail